package com.fantasytenis.shared.domain.skills.usecases

import com.fantasytenis.shared.data.skills.repository.SkillsRepository
import com.fantasytenis.shared.domain.lineup.entity.Category
import com.fantasytenis.shared.domain.skills.entity.*

/**
 * Get skill leaderboard for a category
 */
class GetSkillLeaderboardUseCase(
    private val repository: SkillsRepository
) {
    suspend operator fun invoke(
        category: Category,
        gender: Gender? = null,
        limit: Int = 50,
        offset: Int = 0
    ): Result<Pair<List<SkillLeaderboardEntry>, Int>> {
        return repository.getLeaderboard(category, gender, limit, offset)
    }
}

/**
 * Get player skill history
 */
class GetPlayerSkillHistoryUseCase(
    private val repository: SkillsRepository
) {
    suspend operator fun invoke(
        playerId: String,
        weeks: Int = 8
    ): Result<PlayerSkillHistory> {
        return repository.getPlayerHistory(playerId, weeks)
    }
}

/**
 * Get trending players (biggest skill changes)
 */
class GetTrendingPlayersUseCase(
    private val repository: SkillsRepository
) {
    suspend operator fun invoke(
        direction: TrendDirection = TrendDirection.UP,
        limit: Int = 10
    ): Result<List<TrendingPlayer>> {
        return repository.getTrendingPlayers(direction, limit)
    }
}

/**
 * Get hidden gem players (undervalued based on ranking vs skills)
 */
class GetHiddenGemsUseCase(
    private val repository: SkillsRepository
) {
    suspend operator fun invoke(limit: Int = 10): Result<List<HiddenGemPlayer>> {
        return repository.getHiddenGems(limit)
    }
}
